import { ShapeProps } from '../../../../../Interface/chart-v3/chart-properties.interface';
import ChartShapeProperty from '../../../chart-shape-property';
import { IChartShapeProperty, NullableDeep } from '../../../chart-shape-property.interface';

export class HighLowLineProperty extends ChartShapeProperty implements IChartShapeProperty {
    public updateProps(updateProps: Partial<ShapeProps>, removeProps?: Partial<NullableDeep<ShapeProps>>): void {
        const subChartModel = this.context.getSubChartModel();
        subChartModel.updateAndRemoveProps({ highLowLines: updateProps }, { highLowLines: removeProps });
    }
}
